/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/quotes */

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SidenavComponent } from "./sidenav/sidenav.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatListModule } from "@angular/material/list";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSelectModule } from "@angular/material/select";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTableModule } from "@angular/material/table";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatPaginatorModule } from "@angular/material/paginator";
import { AuditTrailComponent } from "./audit-trail/audit-trail.component";
import { LoginComponent } from "./login/login.component";
import { MatDialogModule } from "@angular/material/dialog";
import { ViewDocumentComponent } from "./audit-trail/view-document/view-document.component";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { ProgressSpinnerComponent } from "./progress-spinner/progress-spinner.component";
import { CategoryComponent } from "./chatbot/category/category.component";
import { SubCategoryComponent } from "./chatbot/sub-category/sub-category.component";
import { QuestionAnswerKeywordComponent } from "./chatbot/question-answer-keyword/question-answer-keyword.component";
import { ChatbotHistoryComponent } from "./chatbot/chatbot-history/chatbot-history.component";
import { ChatbotComponent } from "./chatbot/chatbot.component";
import { AddEditCategoryComponent } from "./chatbot/category/add-edit-category/add-edit-category.component";
import { AddEditSubCategoryComponent } from "./chatbot/sub-category/add-edit-sub-category/add-edit-sub-category.component";
import { AddEditQuestionAnswerKeywordComponent } from "./chatbot/question-answer-keyword/add-edit-question-answer-keyword/add-edit-question-answer-keyword.component";
import { MyGrievanceComponent } from "./grievance/internal-user/my-grievance/my-grievance.component";
import { CreateGrievanceComponent } from "./grievance/internal-user/create-grievance/create-grievance.component";
import { GrievanceDialogComponent } from "./grievance/grievance-dialog/grievance-dialog.component";
import { ViewGrievanceComponent } from "./grievance/internal-user/view-grievance/view-grievance.component";
import { OtpDialogComponent } from "./grievance/otp-dialog/otp-dialog.component";
import { NgOtpInputModule } from "ng-otp-input";
import { RegSupportUserrComponent } from "./grievance/support-user/raise-grievance/reg-support-userr/reg-support-user.component";
import { SuppportUserAssignedGrievanceComponent } from "./grievance/support-user/assign-grievances/suppport-user-assigned-grievance/support-user-assigned-grievance.component";
import { AssignedGrievanceViewComponent } from "./grievance/support-user/assign-grievances/assigned-grievance-view/assigned-grievance-view.component";
import { SupportCreateGrievanceListComponent } from "./grievance/support-user/raise-grievance/support-create-grievance-list/support-create-grievance-list.component";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { CommonModule, DatePipe } from "@angular/common";
import { AssginedGrievanceViewReplyComponent } from "./grievance/support-user/assign-grievances/assgined-grievance-view-reply/assgined-grievance-view-reply.component";
import { ViewattachmentComponent } from "./grievance/internal-user/viewattachment/viewattachment.component";
import { AssignedObjectionSuggestionListComponent } from "./grievance/support-user/assigned-objections-and-suggestions/assigned-objection-suggestion-list/assigned-objection-suggestion-list.component";
import { ViewAssignedObjectionSuggestionListComponent } from "./grievance/support-user/assigned-objections-and-suggestions/view-assigned-objection-suggestion-list/view-assigned-objection-suggestion-list.component";
import { AddGrievanceTypeComponent } from "./grievance/support-user/crud/grievance-type/add-grievance-type/add-grievance-type.component";
import { ListGrievanceTypeComponent } from "./grievance/support-user/crud/grievance-type/list-grievance-type/list-grievance-type.component";
import { UpdateGrievanceTypeComponent } from "./grievance/support-user/crud/grievance-type/update-grievance-type/update-grievance-type.component";
import { AddObjectionSuggestionComponent } from "./grievance/support-user/crud/objection-suggestion-type/add-objection-suggestion/add-objection-suggestion.component";
import { ListObjectionSuggestionComponent } from "./grievance/support-user/crud/objection-suggestion-type/list-objection-suggestion/list-objection-suggestion.component";
import { UpdateObjectionSuggestionComponent } from "./grievance/support-user/crud/objection-suggestion-type/update-objection-suggestion/update-objection-suggestion.component";
import { ReportComponent } from "./grievance/support-user/grievance-report/report.component";
import { ObjectionSuggestionReportComponent } from "./grievance/support-user/objection-suggestion-report/objection-suggestion-report.component";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatRadioModule } from "@angular/material/radio";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { CloseGrievanceDialogComponent } from "./grievance/close-grievance-dialog/close-grievance-dialog.component";
import { AttachmentErrorDialogComponent } from "./grievance/attachment-error-dialog/attachment-error-dialog.component";
import { GrievanceExistDialogComponent } from "./grievance/grievance-exist-dialog/grievance-exist-dialog.component";
import { MasterGrievanceListComponent } from "./grievance/support-user/master-grievance-list/master-grievance-list.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { GoogleChartsModule } from "angular-google-charts";

import { RecaptchaModule } from "ng-recaptcha";
import { HomeComponent } from "./secure/home/home.component";
import { NewDashboardComponent } from "./secure/new-dashboard/new-dashboard.component";
import { NewDashboardLotteryWiseComponent } from "./secure/new-dashboard-lotterywise/new-dashboard-lotterywise.component";
import { NewDashboardSchemeWiseComponent } from "./secure/new-dashboard-schemewise/new-dashboard-schemewise.component";
import { ModerationListComponent } from "./secure/moderation-list/moderation-list.component";

import { HttpConfigInterceptor } from "./httpconfig.interceptor";
import { ModerationComponent } from "./secure/moderation/moderation.component";
import { ModerationDocumentComponent } from "./secure/moderation-document/moderation-document.component";
import { ModerationAuditTrailListComponent } from "./secure/moderation-audit-trail-list/moderation-audit-trail-list.component";
import { ModerationAuditTrailComponent } from "./secure/moderation-audit-trail/moderation-audit-trail.component";

import { DashboardCardComponent } from "./components/dashboard-card/dashboard-card.component";
import { ReportsComponent } from "./secure/reports/reports.component";
import { OrganizationListComponent } from "./secure/master/organization/list/organization-list.component";
import { OrganizationAUComponent } from "./secure/master/organization/au/organization-au.component";
import { RouteReuseStrategy } from "@angular/router";
import { BoardListComponent } from "./secure/master/board/list/board-list.component";
import { BoardAUComponent } from "./secure/master/board/au/board-au.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule, MAT_DATE_LOCALE } from "@angular/material/core";
import { RoleListComponent } from "./secure/master/role/list/role-list.component";
import { RoleAUComponent } from "./secure/master/role/au/role-au.component";
import { UserListComponent } from "./secure/master/user/list/user-list.component";
import { UserAUComponent } from "./secure/master/user/au/user-au.component";
import { ImportMasterComponent } from "./secure/import-master/import-master.component";
import { PaymentReconciliationComponent } from "./secure/payment-reconciliation/payment-reconciliation.component";
import { PaymentReconciliationModalComponent } from "./secure/payment-reconciliation-modal/payment-reconciliation-modal.component";
import { FieldErrorComponent } from "./components/field-error/field-error.component";
import { DefaultPasswordModalComponent } from "./secure/master/user/au/default-password-modal/default-password-modal.component";
import { CallCenterSearchComponent } from "./secure/call-center/search/call-center-search.component";
import { CallCenterViewComponent } from "./secure/call-center/search/view/call-center-view.component";
import { CallCenterTransactionModalComponent } from "./secure/call-center/search/view/transaction-modal/transaction-modal.component";
import { SchemeListComponent } from "./secure/master/scheme/list/scheme-list.component";
import { SchemeAUComponent } from "./secure/master/scheme/au/scheme-au.component";
import { FeatureListComponent } from "./secure/master/feature/list/feature-list.component";
import { FeatureAUComponent } from "./secure/master/feature/au/feature-au.component";
import { MasterGrievanceViewComponent } from "./grievance/support-user/master-grievance-view/master-grievance-view.component";
import { LotteryAuComponent } from "./secure/master/lottery/au/lottery-au.component";
import { LotteryListComponent } from "./secure/master/lottery/list/lottery-list.component";
import { RegistrationComponent } from "./audit-trail/registration/registration.component";
import { ApplicationComponent } from "./audit-trail/application/application.component";
import { PaymentComponent } from "./audit-trail/payment/payment.component";
// import { MatSortModule } from "@angular/material/sort";
import { AddEscalationDurationComponent } from "./grievance/support-user/crud/escalation-duration/add-escalation-duration/add-escalation-duration.component";
// import { ListEscalationDurationComponent } from "./grievance/support-user/crud/escalation-duration/list-escalation-duration/list-escalation-duration.component";
import { UpdateEscalationDurationComponent } from "./grievance/support-user/crud/escalation-duration/update-escalation-duration/update-escalation-duration.component";
import { ListEscalationDurationComponent } from "./grievance/support-user/crud/escalation-duration/list-escalation-duration/list-escalation-duration.component";
import { MatSortModule } from "@angular/material/sort";
import { BankMasterListComponent } from "./secure/bank-master/list/bank-master-list.component";
import { BankMasterAUComponent } from "./secure/bank-master/au/bank-master-au.component";
import { MatMenuModule } from "@angular/material/menu";
import { FaqDialogComponent } from "./grievance/faq-dialog/faq-dialog.component";
import { MatTabsModule } from "@angular/material/tabs";
import { AssignModerationModalComponent } from "./secure/home/assign-moderation-modal/assign-moderation-modal.component";
import { RegistrationReportComponent } from "./audit-trail/registration-report/registration-report.component";
import { CheckDocumentImageComponent } from "./audit-trail/check-document-image/check-document-image.component";
import { ProfileDetailsComponent } from "./audit-trail/profile-details/profile-details.component";
import { PaymentPendingTransactionsComponent } from "./secure/payment-pending-transactions/payment-pending-transactions.component";
import { PushMlModalComponent } from "./secure/moderation-list/push-ml-modal/push-ml-modal.component";
import { GenerateSummaryReportComponent } from "./audit-trail/generate-summary-report/generate-summary-report.component";
import { ViewProfileDocumentComponent } from "./audit-trail/profile-details/view-profile-document/view-profile-document.component";
import { NocDashboardComponent } from "./secure/noc-dashboard/noc-dashboard.component";
import { ChangePasswordComponent } from "./secure/change-password/change-password.component";
import { AllocateGroupComponent } from "./secure/allocate-group/allocate-group.component";
import { UserChatsComponent } from "./audit-trail/user-chats/user-chats.component";
import {
  NgxMatDatetimePickerModule,
  NgxMatTimepickerModule,
  NgxMatNativeDateModule,
} from "@angular-material-components/datetime-picker";
import { NgxMatMomentModule } from "@angular-material-components/moment-adapter";
import { ExportAppsComponent } from "./secure/export-apps/export-apps.component";
import { ExportPhotosComponent } from "./secure/export-photos/export-photos.component";
import { ExportPolComponent } from "./secure/export-pol/export-pol.component";
import { CreateAssetComponent } from "./audit-trail/blockchain/create-asset/create-asset.component";
import { GetAllAssetsComponent } from "./audit-trail/blockchain/get-all-assets/get-all-assets.component";
import { GetAssetByIdComponent } from "./audit-trail/blockchain/get-asset-by-id/get-asset-by-id.component";
import { ImportResultsComponent } from "./secure/import-results/import-results.component";
import { ImportBulkPolComponent } from "./secure/import-bulkPol/import-bulkPol.component";

import { AnnouncementListComponent } from "./secure/announcement/list/announcement-list.component";
import { AnnouncementAuComponent } from "./secure/announcement/au/announcement-au.component";

import { ApplicationListComponent } from "./secure/document-verification/list/application-list.component";
import { ActiveWaitlistComponent } from "./secure/active-reverse-waitlist/active-waitlist/active-waitlist.component";
import { ShiftTenementsComponent } from "./secure/shift-tenements/shift-tenements.component";
import { SopManagementListComponent } from "./secure/sop-management/list/sop-management-list.component";
import { SopManagementAuComponent } from "./secure/sop-management/au/sop-management-au.component";
import { ViewPdfComponent } from "./secure/view-pdf/view-pdf.component";
import { ViewApplicationDtlComponent } from "./secure/view-application/view/view-application-dtl.component";
import { ViewApplicationComponent } from "./secure/view-application/view-application.component";
import { PdfJsViewerModule } from "ng2-pdfjs-viewer";
import { ProApproverComponent } from "./secure/pro-approver/pro-approver.component";
import { ProApproverListComponent } from "./secure/pro-approver-list/pro-approver-list.component";
import { ProRejectCaseComponent } from "./secure/pro-approver/reject-case/pro-reject-case.component";
import { LoaderComponent } from "./secure/loader/loader.component";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { ProApproveCaseComponent } from "./secure/pro-approver/approve-case/pro-approve-case.component";
import { QueryExecutorListComponent } from "./secure/query-executor-list/query-executor-list.component";
import { QueryExecutorComponent } from "./secure/query-executor/query-executor.component";
import { SopMasterAuComponent } from "./secure/sop-master/au/sop-master.component";
import { InstallmentConfigComponent } from "./secure/installment-config/installment-config.component";
import { InstallmentConfigModalComponent } from "./secure/installment-config/installment-config-modal/installment-config-modal.component";
import { NocApproverComponent } from "./secure/noc-approver/noc-approver.component";
import { NocApproverListComponent } from "./secure/noc-approver-list/noc-approver-list.component";
import { NocRejectCaseComponent } from "./secure/noc-approver/reject-case/noc-reject-case.component";
import { NocApproveCaseComponent } from "./secure/noc-approver/approve-case/noc-approve-case.component";
import { SopMasterListComponent } from "./secure/sop-master/list/sopMaster-list.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { CorrigendumApplicationComponent } from "./secure/corrigendum-upload/table/corrigendum-table.component";
import { CorrigendumApplicationFormComponent } from "./secure/corrigendum-upload/form/corrigendum-form.component";
import { ModalComponent } from "./secure/corrigendum-upload/modal/modal.component";
import { PdfViewerModalComponent } from "./secure/corrigendum-upload/pdfViewerModal/pdfViewerModal.component";
import { EmailSmsComponent } from "./secure/email-sms-notification/email-sms.component";
import { EmailDashboardComponent } from "./secure/email-dashboard/email-dashboard.component";

import { PaymentSettlementComponent } from "./secure/payment-settlement/payment-settlement.component";
import { ViewPaymentDtlComponent } from "./secure/payment-settlement/view/view-payment-dtl.component";

import { DocumentVerificationComponent } from "./secure/document-verificationAllotment/document-verification.component";
import { ViewDocumentDtlComponent } from "./secure/document-verificationAllotment/view/view-document-dtl.component";
import { POLDocumentVerificationComponent } from "./secure/document-verificationPol/poldocument-verification.component";
import { EngineeringDocumentVerificationComponent } from "./secure/document-verificationEnginering/engineringdocument-verification.component";
import { ApplicantAuditTrailComponent } from "./secure/applicant-auditTrail/applicantAudit-trail.component";
import { ClerkDocumentVerificationComponent } from "./secure/document-verificationClerk/clerkdocument-verification.component";
import { ViewAuditTrailDocumentDtlComponent } from "./secure/applicant-auditTrail/view/view-auditTrail-document-dtl.component";
import { ViewPolDocumentDtlComponent } from "./secure/document-verificationPol/view/view-poldocument-dtl.component";
import { ViewEngineeringDocumentDtlComponent } from "./secure/document-verificationEnginering/view/view-enginerdocument-dtl.component";
import { ViewClerkDocumentDtlComponent } from "./secure/document-verificationClerk/view/view-clerk-document-dtl.component";
import { ProcessRefundComponent } from "./secure/process-refund/process-refund.component";
import { SignOffReportListComponent } from "./secure/signoff-report/list/signoff-report-list.component";
import { SignOffReportAUComponent } from "./secure/signoff-report/au/signoff-report-au.component";
import { NumberOnlyCommonDirective } from "./services/number-only-common";
import { PublishLettersComponent } from "./secure/publish-letters/publish-letters.component";
import { PublishLettersModalComponent } from "./secure/publish-letters/publish-letters-modal/publish-letters-modal.component";
import { DashboardListComponent } from "./secure/dashboard/dashboard-list.component";
import { nocPendingDashboardComponent } from "./secure/nocPendingDashboard/nocPendingDashboard.component";
import { DashBoardViewApplicationDtlComponent } from "./secure/dashboard/view/dashboard-view-app-dtl.component";
import { TdsRejectComponent } from "./secure/payment-settlement/view/reject-case/tds-reject-case.component";
import { AllotmentLetterGeneratation } from "./secure/allotment-letter-generatation/allotment-letter-generatation.component";
import { CasteValRefLetterApproverListComponent } from "./secure/caste-val-ref-letter-approver-list/caste-val-ref-letter-approver-list.component";
import { CasteValRefLetterApproverComponent } from "./secure/caste-val-ref-letter-approver/caste-val-ref-letter-approver.component";
import { NumbersOnlyDirective } from "./secure/util/number-only";
import { MDFreedomFighterComponent } from "./secure/moderation-document-new/freedom-fighter/md-freedom-fighter.component";
import { MDExServicemanComponent } from "./secure/moderation-document-new/ex-serviceman/md-ex-serviceman.component";
import { MDDefenceFamilyComponent } from "./secure/moderation-document-new/defence-family/md-defence-family.component";
import { MDCentralGovernmentComponent } from "./secure/moderation-document-new/central-government/md-central-government.component";
import { MDStateGovernmentComponent } from "./secure/moderation-document-new/state-government/md-state-government.component";
import { MDArtistComponent } from "./secure/moderation-document-new/artist/md-artist.component";
import { MDPhysicallyHandicappedComponent } from "./secure/moderation-document-new/physically-handicapped/md-physically-handicapped.component";
import { MDDomicileComponent } from "./secure/moderation-document-new/domicile/md-domicile.component";
import { MDCasteCertificateComponent } from "./secure/moderation-document-new/caste-certificate/md-caste-certificate.component";
import { MDCasteValidityComponent } from "./secure/moderation-document-new/caste-validity/md-caste-validity.component";
import { MDIncomeCertificateComponent } from "./secure/moderation-document-new/income-certificate/md-income-certificate.component";
import { MDITRComponent } from "./secure/moderation-document-new/itr/md-itr.component";
import { ApplicantApproverListComponent } from "./secure/applicant-editing-approver-list/applicant-approver-list.component";
import { ApplicantApproverDtlComponent } from "./secure/applicant-editing-approver-list/applicant-approver-dtl/applicant-approver-dtl.component";
import { PhotoUploadComponent } from "./secure/applicant-editing-approver-list/applicant-approver-dtl/photo-upload/photo-upload.component";
import { MarriageStatusComponent } from "./secure/applicant-editing-approver-list/applicant-approver-dtl/marriage-status/marriage-status.component";
import { RejectCaseComponent } from "./secure/applicant-editing-approver-list/applicant-approver-dtl/reject-case-modal/reject-case.component";
import {
  IgxLegendModule,
  IgxCategoryChartModule,
} from "igniteui-angular-charts";
import { CanvasJSAngularChartsModule } from "@canvasjs/angular-charts";
import { BoardDocumentsListComponent } from "./secure/board-documents-list/board-documents-list.component";
import { BoardDocumentComponent } from "./secure/board-document/board-document.component";
import { ViewImageComponent } from "./secure/applicant-editing-approver-list/view-image-modal/view-image.component";
import { LettersListComponent } from "./secure/letters-generate-list/letters-generate-list.component";
import { AgreementIndxUpldComponent } from "./secure/agreement-indx-upld/agreement-indx-upld.component";
import { AgreementIndxUpldDtlComponent } from "./secure/agreement-indx-upld/view/agreement-indx-upld-dtl.component";
import { UploadFileModalComponent } from "./secure/upload-file-modal/upload-file-modal.component";
import { TenementExchangeListComponent } from "./secure/tenement-exchange/list/tenement-exchange-list.component";
import { TenementExchangeFormComponent } from "./secure/tenement-exchange/form/tenement-exchange-form.component";
import { BlockchainVerifyListComponent } from "./secure/blockchain-verify-list/blockchain-verify-list.component";
import { VerifyBlockchainComponent } from "./secure/blockchain-verify-list/verify-blockchain/verify-blockchain.component";
// import { PaymentDefaulterActionComponent } from "./secure/payment-defaulter-action/payment-defaulter-action.component";
import { ViewImageOnlyComponent } from "./secure/view-image-only/view-image-only.component";
import { AppealHearingComponent } from "./secure/applicant-hearing/appeal-hearing.component";
import { AppealRejectComponent } from "./secure/applicant-hearing/reject-case/appeal-reject-case.component";
import { AppealCallHearingComponent } from "./secure/applicant-hearing/hearing-case/appeal-call-hearing.component";
import { ViewAppealHearingDtlComponent } from "./secure/applicant-hearing/view/appeal-hearing-dtl.component";
import { DownloadCastvalidityZipComponent } from "./secure/download-castvalidityzip/download-castvalidityzip.component";
import { DashboardDataentryListComponent } from "./secure/dashboard-dataentry-list/dashboard-dataentry-list.component";
import { DashboardDataEntryComponent } from "./secure/dashboard-dataentry/dashboard-dataentry.component";
import { UpdatePossessionDtlListComponent } from "./secure/update-possession-dtl-list/update-possession-dtl-list.component";
import { UpdatePossessionDtlComponent } from "./secure/update-possession-dtl/update-possession-dtl.component";

import { NewLotteryListComponent } from "./secure/master/new-lottery/new-list/new-lottery-list.component";
import { NewLotteryComponent } from "./secure/master/new-lottery/new-lottery.component";
import { NewLotteryAuComponent } from "./secure/master/new-lottery/new-au/new-lottery-au.component";
import { UploadImageModalComponent } from "./secure/upload-image-modal/upload-image-modal.component";
import { CasteValViewApplicationComponent } from "./secure/caste-val-verification/view/caste-val-verification-view.component";
import { CasteValidityViewProfileDocumentComponent } from "./secure/caste-val-verification/view-profile-document/caste-val-view-profile-document.component";
import { CasteValVerificationListComponent } from "./secure/caste-val-verification/list/caste-val-verification-list.component";
import { ProfileResetComponent } from "./secure/profile-reset/profile-reset.component";
import { PaymentDashboardComponent } from "./secure/payment-dashboard/payment-dashboard.component";
import { CroreFormatterPipe } from "./services/croreFormatter.pipe";
import { ImageViewerModalComponent } from "./secure/corrigendum-upload/imageViewerModal/imgViewerModal.component";
// import { CasteValViewApplicationComponent } from "./secure/caste-val-verification/view/caste-val-verification-view.component";
// import { CasteValidityViewProfileDocumentComponent } from "./secure/caste-val-verification/view-profile-document/caste-val-view-profile-document.component";
// import { CasteValVerificationListComponent } from "./secure/caste-val-verification/list/caste-val-verification-list.component";
import { ViewApplicationDocumentsComponent } from "./secure/view-application-documents/view-application-documents.component";
import { ViewApplicationDocumentDtlComponent } from "./secure/view-application-documents/view/view-application-document-dtl.component";
import { PaymentExtensionListComponent } from "./secure/payment-extension/payment-extension-list.component";
import { PaymentExtensionDtlComponent } from "./secure/payment-extension/view/payment-extension-dtl.component";
import { SMSNotificationLotteryResultListComponent } from "./secure/sms-notif-lot-result-list/sms-notif-lot-result-list.component";
import { ApplicantCountReport } from "./secure/application-count-report/application-count-report.component";
import { TenementModalComponent } from "./secure/tenement-exchange/tenement-modal/tenement-modal";
import { InstallmentConfigEditModalComponent } from "./secure/installment-config/installment-config-edit-model/installment-config-edit-model.component";
import { UpdateSpousePanDetails } from "./secure/update-spouse-pan-details/update-spouse-pan.component";
import { AppealApproveDocComponent } from "./secure/applicant-hearing/approve-doc-case/appeal-approve-doc-case.component";
import { ApplicationDocumentView } from "./secure/applicant-document-view/applicant-document-view.component";
import { BlockchainDashboardComponent } from "./secure/blockchain-dashboard/blockchain-dashboard.component";
import { ChangeEligibilityComponent } from "./secure/change-eligibility/change-eligibility.component";
import { RevertChangeEligibilityComponent } from "./secure/revert-change-eligibility/revert-change-eligibility.component";
import { PanAdharUpdateDetails } from "./secure/pan-adhar-home/pan-adhar-home.component";
import { UpdateAadharDetails } from "./secure/pan-adhar-home/update-adhar/update-adhar.component";
import { EBillingReportComponent } from "./secure/report_e_billing/report_e_billing.component";
import { SpouseAadharChange } from "./secure/pan-adhar-home/change-spouse-aadhar/change-spouse-aadhar.component";
import { BlockchainAuditTrailComponent } from "./secure/blockchain-verify-list/blockchain-audittrail/blockchain-audittrail.component";
import { CounterNewDirective } from "./secure/util/counter-new.directive";
import { UploadTenementMasterComponent } from "./secure/engineer-tenement-upload/form/upload-tenement-master.component";
import { AppealButtonShowComponent } from "./secure/change-eligibility/appeal-button-show/appeal-button-show.component";
import { DownloadProjectTenementComponent } from "./secure/download-project-tenement/download-project-tenement.component";
import { PaymentDefaulterListComponent } from "./secure/payment-defaulter-list/payment-defaulter-list.component";
import { UpdateApplicantMobileNoAndEmailId } from "./secure/pan-adhar-home/update-applicant-mob-email/update-applicant-mob-email.component";
import { UpdateSpouseEmailId } from "./secure/pan-adhar-home/update-spouse-email/update-spouse-email.component";
import { SurrReqVerificationComponent } from "./secure/surr-req-verification/surr-req-verification.component";
import { SurrReqApproveComponent } from "./secure/surr-req-verification/view/approve-case/surr-req-approve-case.component";
import { SurrReqRejectComponent } from "./secure/surr-req-verification/view/reject-case/surr-req-reject-case.component";
//import { ViewSurrReqDtlComponent } from "./secure/surr-req-verification/view/view-surr-req-dtl.component";
import { PaymentRefundComponent } from "./secure/payment-refund/payment-refund.component";
import { UploadTenementMasterList } from "./secure/engineer-tenement-upload/list/upload-tenement-list.component";
import { TenementEditModalComponent } from "./secure/engineer-tenement-upload/edit-modal/edit-modal.component";
import { UploadCorriegendumComponent } from "./secure/upload-corriegendum/upload-corriegendum.component";
import { ViewPaymentRefundDtlComponent } from "./secure/payment-refund/view/view-payment-refund-dtl.component";
import { ProjectListComponent } from "./secure/project/list/project-list.component";
import { ProjectAUComponent } from "./secure/project/au/project-au.component";
import { AmenityListComponent } from "./secure/amenity/list/amenity-list.component";
import { AmenityAUComponent } from "./secure/amenity/au/amenity-au.component";
import { RefundRejectComponent } from "./secure/payment-refund/reject-case/refund-reject-case.component";
import { InvoiceTrackingComponent } from "./secure/invoice-tracking/invoice-tracking.component";
import { InvoiceTrackingFormComponent } from "./secure/invoice-tracking/form/invoice-tracking-form.component";
import { InvoiceModal } from "./secure/invoice-tracking/invoice-modal/invoice-modal";
import { GeneratedInvoiceFormComponenet } from "./secure/invoice-tracking/generated-invoice/generated-invoice-list.component";
import { GeneratedInvoiceView } from "./secure/invoice-tracking/generated-invoice-view/generated-invoice-view.component";
import { ViewSurrReqDtlComponent } from "./secure/surr-req-verification/view/view-surr-req-dtl.component";
import { PaymentRefundUploadComponent } from "./secure/payment-refund-upload/payment-refund-upload.component";
import { DownloadApplicantPanAdharPolZipComponent } from "./secure/download-applicant-pan-adhar-pol-zip/download-applicant-pan-adhar-pol-zip.component";
import { ExtendedAcceptanceComponent } from "./secure/extend-acceptance/extend-acceptance.component";
import { ExtendedAcceptanceModalComponent } from "./secure/extend-acceptance/extend-data-modal/extend-data-modal.component";
import { NewPaymentExtensionListComponent } from "./secure/new-payment-extension/new-payment-extension-list.component";
import { AdvAdvertisementListComponent } from "./secure/adv-advertisement-list/adv-advertisement-list.component";
import { MomMeetingTypeComponent } from "./secure/mom-meeting-type/mom-meeting-type.component";
import { MomMeetingTypeUpdateComponent } from "./secure/mom-meeting-type/mom-meeting-type-update/mom-meeting-type-update.component";
import { MomMeetingComponent } from "./secure/mom-meeting/mom-meeting/mom-meeting.component";
import { MomStartMeetingComponent } from "./secure/mom-meeting/mom-start-meeting/mom-start-meeting.component";
import { MomApproveMeetingComponent } from "./secure/mom-meeting/mom-approve-meeting/mom-approve-meeting.component";
import { TenementInstallmentConfigAddModalComponent } from "./secure/tenement-installment-config/tenement-installment-config-add-model/tenement-installment-config-add-model.component";
import { TenementInstallmentConfigComponent } from "./secure/tenement-installment-config/tenement-installment-config.component";
import { invoiceSettlementModal } from "./secure/invoice-tracking/invoice-settlement/invoice-settlement";
import { PendencyDashboarComponent } from "./secure/Pendency-Dashboard/pendency-dashboard.component";
import { MomRecordMeetingComponent } from "./secure/mom-meeting/mom-record-meeting/mom-record-meeting.component";
import { PaymentDefaulterDtlComponent } from "./secure/payment-defaulter-list/view/payment-defaulter-view.component";
import { RefundCloseComponent } from "./secure/payment-refund/close-case/refund-close-case.component";
import { ReopenCaseComponent } from "./secure/payment-refund/reopen-case/reopen-case.component";
import { AddNomineeOfApplicationComponent } from "./secure/add-nominee/add-nominee.component";
import { AddNomineeFormComponent } from "./secure/add-nominee/add-nominee-form/add-nominee-form.component";
import { NumberTwoDigitOnlyDirective } from "./secure/util/number-two-digit-only";
import { ConfirmDataModalComponent } from "./secure/confirm-data-modal/confirm-data-modal.component";
import { RevertActivatedWaitlistComponent } from "./secure/revert-activated-waitlist/revert-activated-waitlist.component";
import { ChnageRejectedApplicantAadharDetails } from "./secure/pan-adhar-home/change-rejected-applicant-adhar/change-rejected-applicant-adhar.component";
import { ViewWtlstDtlsModalComponent } from "./secure/view-wtlst-dtls-model/view-wtlst-dtls-model.component";
import { SchemeEditorComponent } from "./secure/scheme-editor/scheme-editor.component";
import { ExtendedSurrenderComponent } from "./secure/extend-surrender/extend-surrender.component";
import { ExtendedSurrenderModalComponent } from "./secure/extend-surrender/extend-data-modal/extend-data-modal.component";
import { SchemeEditorModalComponent } from "./secure/scheme-editor/scheme-editor-modal/scheme-editor-modal.component";
import { FinancialYearListComponent } from "./secure/financial-year/list/financial-year-list.component";
import { FinancialYearAUComponent } from "./secure/financial-year/au/financial-year-au.component";
import { ProfileDetailsNewComponent } from "./audit-trail/profile-details-new/profile-details-new.component";
import { ViewDocumentNewComponent } from "./audit-trail/profile-details-new/view-document-new/view-document-new.component";
import { ICTDashboardComponent } from "./secure/ict-dashboard/ict-dashboard.component";
import { SentenceCasePipe } from "./secure/ict-dashboard/sentencase.pipe";

@NgModule({
  declarations: [
    AppComponent,
    SidenavComponent,
    AuditTrailComponent,
    LoginComponent,
    ViewDocumentComponent,
    ProgressSpinnerComponent,
    CategoryComponent,
    SubCategoryComponent,
    QuestionAnswerKeywordComponent,
    ChatbotHistoryComponent,
    ChatbotComponent,
    AddEditCategoryComponent,
    AddEditSubCategoryComponent,
    AddEditQuestionAnswerKeywordComponent,
    OtpDialogComponent,
    MyGrievanceComponent,
    CreateGrievanceComponent,
    GrievanceDialogComponent,
    ViewGrievanceComponent,
    RegSupportUserrComponent,
    SuppportUserAssignedGrievanceComponent,
    AssignedGrievanceViewComponent,
    SupportCreateGrievanceListComponent,
    AssginedGrievanceViewReplyComponent,
    ViewattachmentComponent,
    ViewGrievanceComponent,
    UploadImageModalComponent,
    CasteValViewApplicationComponent,
    CasteValidityViewProfileDocumentComponent,
    CasteValVerificationListComponent,
    AssignedObjectionSuggestionListComponent,
    ViewAssignedObjectionSuggestionListComponent,
    AddGrievanceTypeComponent,
    ListGrievanceTypeComponent,
    UpdateGrievanceTypeComponent,
    AddObjectionSuggestionComponent,
    UpdateObjectionSuggestionComponent,
    ListObjectionSuggestionComponent,
    ReportComponent,
    ObjectionSuggestionReportComponent,
    CloseGrievanceDialogComponent,
    AttachmentErrorDialogComponent,
    GrievanceExistDialogComponent,
    MasterGrievanceListComponent,
    HomeComponent,
    ModerationListComponent,
    ModerationComponent,
    ModerationDocumentComponent,
    DashboardListComponent,
    ModerationAuditTrailListComponent,
    ModerationAuditTrailComponent,
    DashboardCardComponent,
    ReportsComponent,
    RoleListComponent,
    RoleAUComponent,
    UserListComponent,
    UserAUComponent,
    OrganizationListComponent,
    DashBoardViewApplicationDtlComponent,
    OrganizationAUComponent,
    // BoardListComponent,
    // BoardAUComponent
    BoardListComponent,
    BoardAUComponent,
    ImportMasterComponent,
    ReportsComponent,
    PaymentReconciliationComponent,
    PaymentReconciliationModalComponent,
    FieldErrorComponent,
    DashboardCardComponent,
    DefaultPasswordModalComponent,
    CallCenterSearchComponent,
    CallCenterViewComponent,
    CallCenterTransactionModalComponent,
    SchemeListComponent,
    SchemeAUComponent,
    MasterGrievanceViewComponent,
    LotteryAuComponent,
    LotteryListComponent,
    FeatureListComponent,
    FeatureAUComponent,
    RegistrationComponent,
    ApplicationComponent,
    PaymentComponent,
    AddEscalationDurationComponent,
    ListEscalationDurationComponent,
    UpdateEscalationDurationComponent,
    BankMasterListComponent,
    BankMasterAUComponent,
    FaqDialogComponent,
    AssignModerationModalComponent,
    RegistrationReportComponent,
    CheckDocumentImageComponent,
    ProfileDetailsComponent,
    GenerateSummaryReportComponent,
    ViewProfileDocumentComponent,
    PaymentPendingTransactionsComponent,
    PaymentExtensionListComponent,
    PaymentExtensionDtlComponent,
    PushMlModalComponent,
    UserChatsComponent,
    NocDashboardComponent,
    ChangePasswordComponent,
    AllocateGroupComponent,
    ChangePasswordComponent,
    ExportAppsComponent,
    CreateAssetComponent,
    GetAllAssetsComponent,
    GetAssetByIdComponent,
    ExportPhotosComponent,
    ExportPolComponent,
    ImportResultsComponent,
    AnnouncementListComponent,
    AnnouncementAuComponent,
    ApplicationListComponent,
    ActiveWaitlistComponent,
    ShiftTenementsComponent,
    ViewPdfComponent,
    ViewApplicationComponent,
    ViewApplicationDtlComponent,
    SopManagementListComponent,
    SopManagementAuComponent,
    ProApproverComponent,
    ProApproverListComponent,
    ProRejectCaseComponent,
    ProApproveCaseComponent,
    LoaderComponent,
    QueryExecutorListComponent,
    QueryExecutorComponent,
    SopMasterAuComponent,
    SopMasterListComponent,
    QueryExecutorComponent,
    QueryExecutorComponent,
    InstallmentConfigComponent,
    InstallmentConfigModalComponent,
    NocApproverComponent,
    NocApproverListComponent,
    NocRejectCaseComponent,
    NocApproveCaseComponent,
    CorrigendumApplicationComponent,
    CorrigendumApplicationFormComponent,
    ModalComponent,
    TenementModalComponent,
    PdfViewerModalComponent,
    EmailSmsComponent,
    EmailDashboardComponent,
    PaymentRefundUploadComponent,
    ProcessRefundComponent,
    SignOffReportListComponent,
    SignOffReportAUComponent,
    NumberOnlyCommonDirective,
    PublishLettersComponent,
    PublishLettersModalComponent,
    ImportBulkPolComponent,
    nocPendingDashboardComponent,
    PaymentSettlementComponent,
    PaymentDashboardComponent,
    ViewPaymentDtlComponent,
    TdsRejectComponent,
    RefundRejectComponent,
    RefundCloseComponent,
    LettersListComponent,
    AllotmentLetterGeneratation,
    CasteValRefLetterApproverListComponent,
    CasteValRefLetterApproverComponent,
    MDFreedomFighterComponent,
    MDExServicemanComponent,
    MDDefenceFamilyComponent,
    MDCentralGovernmentComponent,
    MDStateGovernmentComponent,
    MDArtistComponent,
    MDPhysicallyHandicappedComponent,
    NumbersOnlyDirective,
    MDDomicileComponent,
    MDCasteCertificateComponent,
    MDCasteValidityComponent,
    MDIncomeCertificateComponent,
    MDITRComponent,
    ApplicantApproverListComponent,
    ApplicantApproverDtlComponent,
    PhotoUploadComponent,
    MarriageStatusComponent,
    RejectCaseComponent,
    ViewImageComponent,
    ViewImageOnlyComponent,
    BoardDocumentsListComponent,
    BoardDocumentComponent,
    NewDashboardComponent,
    PendencyDashboarComponent,
    NewDashboardLotteryWiseComponent,
    NewDashboardSchemeWiseComponent,
    DocumentVerificationComponent,
    ViewDocumentDtlComponent,
    InvoiceModal,
    invoiceSettlementModal,
    InvoiceTrackingComponent,
    InvoiceTrackingFormComponent,
    GeneratedInvoiceFormComponenet,
    GeneratedInvoiceView,
    POLDocumentVerificationComponent,
    ViewPolDocumentDtlComponent,
    EngineeringDocumentVerificationComponent,
    ApplicantAuditTrailComponent,
    ViewEngineeringDocumentDtlComponent,
    ClerkDocumentVerificationComponent,
    ViewClerkDocumentDtlComponent,
    ViewAuditTrailDocumentDtlComponent,
    AgreementIndxUpldComponent,
    AgreementIndxUpldDtlComponent,
    TenementExchangeListComponent,
    TenementExchangeFormComponent,
    UploadFileModalComponent,
    BlockchainVerifyListComponent,
    VerifyBlockchainComponent,
    AppealHearingComponent,
    AppealRejectComponent,
    AppealApproveDocComponent,
    AppealCallHearingComponent,
    ViewAppealHearingDtlComponent,
    DownloadCastvalidityZipComponent,
    DashboardDataentryListComponent,
    DashboardDataEntryComponent,
    UpdatePossessionDtlListComponent,
    UpdatePossessionDtlComponent,
    UploadFileModalComponent,
    NewLotteryListComponent,
    NewLotteryAuComponent,
    NewLotteryComponent,
    ProfileResetComponent,
    UploadFileModalComponent,
    CroreFormatterPipe,
    ImageViewerModalComponent,
    ViewApplicationDocumentsComponent,
    ViewApplicationDocumentDtlComponent,
    SMSNotificationLotteryResultListComponent,
    ApplicantCountReport,
    InstallmentConfigEditModalComponent,
    UpdateSpousePanDetails,
    ApplicationDocumentView,
    BlockchainDashboardComponent,
    PanAdharUpdateDetails,
    UpdateAadharDetails,
    EBillingReportComponent,
    UpdateAadharDetails,
    SpouseAadharChange,
    UpdateAadharDetails,
    ChangeEligibilityComponent,
    BlockchainAuditTrailComponent,
    UploadTenementMasterComponent,
    UploadTenementMasterList,
    TenementEditModalComponent,
    CounterNewDirective,
    RevertChangeEligibilityComponent,
    AppealButtonShowComponent,
    DownloadProjectTenementComponent,
    PaymentDefaulterListComponent,
    UpdateApplicantMobileNoAndEmailId,
    UpdateSpouseEmailId,
    SurrReqVerificationComponent,
    ViewSurrReqDtlComponent,
    SurrReqRejectComponent,
    SurrReqApproveComponent,
    UploadCorriegendumComponent,
    PaymentRefundComponent,
    ViewPaymentRefundDtlComponent,
    ProjectListComponent,
    ProjectAUComponent,
    AmenityListComponent,
    AmenityAUComponent,
    DownloadApplicantPanAdharPolZipComponent,
    ExtendedAcceptanceComponent,
    ExtendedAcceptanceModalComponent,
    NewPaymentExtensionListComponent,
    AdvAdvertisementListComponent,
    MomMeetingTypeComponent,
    MomMeetingTypeUpdateComponent,
    MomMeetingComponent,
    MomStartMeetingComponent,
    MomApproveMeetingComponent,
    TenementInstallmentConfigComponent,
    TenementInstallmentConfigAddModalComponent,
    MomRecordMeetingComponent,
    PaymentDefaulterDtlComponent,
    ReopenCaseComponent,
    AddNomineeOfApplicationComponent,
    AddNomineeFormComponent,
    NumberTwoDigitOnlyDirective,
    ConfirmDataModalComponent,
    RevertActivatedWaitlistComponent,
    ChnageRejectedApplicantAadharDetails,
    ViewWtlstDtlsModalComponent,
	  SchemeEditorComponent,
    ExtendedSurrenderComponent,
    ExtendedSurrenderModalComponent,
    SchemeEditorModalComponent,
    FinancialYearListComponent,
    FinancialYearAUComponent,
    ProfileDetailsNewComponent,
    ViewDocumentNewComponent,
    ICTDashboardComponent,
    SentenceCasePipe
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    MatInputModule,
    MatFormFieldModule,
    MatSnackBarModule,
    MatDialogModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatTableModule,
    MatPaginatorModule,
    MatExpansionModule,
    NgxMatSelectSearchModule,
    MatCheckboxModule,
    RecaptchaModule,
    MatRadioModule,
    NgOtpInputModule,
    IonicModule.forRoot(),
    MatDatepickerModule,
    MatNativeDateModule,
    MatSortModule,
    MatMenuModule,
    NgxMatSelectSearchModule,

    MatTabsModule,
    NgxChartsModule,
    GoogleChartsModule.forRoot(),
    NgxMatTimepickerModule,
    NgxMatDatetimePickerModule,
    NgxMatMomentModule,
    NgxChartsModule,
    GoogleChartsModule.forRoot(),
    PdfJsViewerModule,
    MatTooltipModule,
    CommonModule,
    IgxLegendModule,
    IgxCategoryChartModule,
    CanvasJSAngularChartsModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    DatePipe,
    InAppBrowser,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },
    { provide: MAT_DATE_LOCALE, useValue: "en-GB" },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
